module.exports = __webpack_public_path__ + "static/img/PFK_Photo3_OurTeam_810x370.4aa5a9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PFK_Photo3_OurTeam_810x370.jpg
// module id = 178
// module chunks = 2